/* this file is transformed by vux-loader */
/* eslint-disable */
import request from '../request'; // 获取我的页面用户信息

export function getMineUser(data) {
  return request.get('/mine/info', {
    params: data
  });
} // 获取我的页面用户信息

export function getUserStateLabel(data) {
  return request.get('/v2/epTag/getUserStateLabel', {
    params: data
  });
} // 修改用户工作状态

export function updateUserStateTag(data) {
  return request.post('/v2/epTag/updateUserStateTag', data);
} // 获取用户工作状态

export function epTagList(data) {
  return request.get('/v2/epTag/list', {
    params: data
  });
} // 获取版本信息

export function epPackageDetail(data) {
  return request.get('/v2/charge/epPackageDetail', {
    params: data
  });
} // 升级续费价格列表

export function renewList(data) {
  return request.get('/v2/charge/list', {
    params: data
  });
} // 问题反馈

export function feedback(data) {
  return request.post('/mine/subSug', data);
}
export var getIdByQRCode = function getIdByQRCode() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request.request({
    url: '/productQR/getIdByQRCode',
    method: 'get',
    params: query
  });
};
export function getSysPhone() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request.get('/v2/system/customServicePhone', {
    params: data
  });
}